export default "__VITE_ASSET__BSm5Ntq___"